import { render, staticRenderFns } from "./UserCreate.vue?vue&type=template&id=dca441a4&scoped=true"
import script from "./UserCreate.vue?vue&type=script&lang=js"
export * from "./UserCreate.vue?vue&type=script&lang=js"
import style0 from "./UserCreate.vue?vue&type=style&index=0&id=dca441a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca441a4",
  null
  
)

export default component.exports